module.exports = __webpack_public_path__ + "static/media/Apr_2026_4.bb4af7ce.webp";